import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Box, Select, MenuItem, FormControl } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import OrderingList from "../Lists/OrderingList";
import { findByKey } from "../../utils/helpers";

const useStyles = makeStyles(theme => ({
  orderingText: {
    ...theme.typography.subtitle1
  }
}));

// TODO: implement actual functionality to update user answer based on selected order in separate ticket
const OrderField = ({ value, numOrderingItems, onChange, disableChange }) => {
  const menuItems = [...Array(numOrderingItems)].map((item, index) => ({
    label: index + 1,
    value: index
  }));
  return (
    <FormControl hiddenLabel fullWidth>
      <Select
        renderValue={value => value + 1}
        variant="filled"
        value={value}
        onChange={({ target: { value } }) => onChange(value)}
        disabled={disableChange}
      >
        {menuItems.map((menuItem, index) => (
          <MenuItem value={menuItem.value} key={index}>
            {menuItem.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const OrderingQuestion = ({
  orderingChoices,
  onAnswerChange,
  existingAnswers,
  disableChange
}) => {
  const classes = useStyles();
  const [orderingLearnerAnswers, setOrderingLearnerAnswers] = useState([]);
  const [showOrderValue, setShowOrderValue] = useState(disableChange);

  useEffect(() => {
    // randomize the order of the answers and set the default order
    if (disableChange) {
      setOrderingLearnerAnswers(existingAnswers);
    }
    // TODO: refactor
    setOrderingLearnerAnswers(
      orderingChoices.map((orderingItem, index) => {
        const existingAnswer =
          existingAnswers &&
          existingAnswers.find(
            ({ answerData, id }) =>
              (answerData && answerData.id === orderingItem.id) ||
              id === orderingItem.id
          );
        return {
          ...orderingItem,
          order:
            existingAnswer && Number.isInteger(existingAnswer.order)
              ? existingAnswer.order
              : ""
        };
      })
    );
  }, [orderingChoices]);

  /**
   * When the learner selects a new order for an item,
   * we find the existing item with the new order and swap
   * their orders to ensure no two items have the same order
   */
  const handleOrderChange = reorderedAnswer => selectedOrder => {
    !showOrderValue && setShowOrderValue(true);
    const newAnswers = [...orderingLearnerAnswers];
    const existingAnswerWithNewOrder = findByKey(
      newAnswers,
      "order",
      selectedOrder
    );
    if (existingAnswerWithNewOrder) {
      existingAnswerWithNewOrder.order = reorderedAnswer.order;
    }
    findByKey(newAnswers, "id", reorderedAnswer.id).order = selectedOrder;
    setOrderingLearnerAnswers(newAnswers);
    onAnswerChange(newAnswers);
  };

  const getCurrentOrderValue = orderingItem => {
    return orderingItem.order;
  };
  return (
    <Box display="flex" flexDirection="column" flex={1} mt={5} mb={2} ml={3.75}>
      <OrderingList
        listItems={orderingLearnerAnswers}
        renderText={orderingItem => (
          <Box
            display="flex"
            alignItems="center"
            dangerouslySetInnerHTML={{ __html: orderingItem.text }}
            className={classes.orderingText}
          />
        )}
        renderOrderField={(orderingItem, index) => (
          <Box width={80}>
            <OrderField
              numOrderingItems={orderingChoices.length}
              orderIndex={index}
              onChange={handleOrderChange(orderingItem)}
              value={getCurrentOrderValue(orderingItem)}
              disableChange={disableChange}
            />
          </Box>
        )}
      />
    </Box>
  );
};

OrderingQuestion.propTypes = {
  orderingAnswers: PropTypes.array,
  onAnswersChange: PropTypes.func
};

export default OrderingQuestion;
